"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Ticket } from "@/lib/types/database";

/**
 * Ticket Attachments Tab Component
 */
export const TicketAttachmentsTab = React.memo(({ item }: TabContentProps<Ticket>) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Attachments</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8 text-gray-500">
          <MessageCircle className="h-12 w-12 mx-auto mb-4 text-gray-300" />
          <p>No attachments found for this ticket</p>
          <p className="text-sm text-gray-400 mt-2">Attachments will appear here when uploaded</p>
        </div>
      </CardContent>
    </Card>
  );
});

TicketAttachmentsTab.displayName = "TicketAttachmentsTab";
